import { FC } from 'react'

import { CheckoutFlowVersion } from '@/enums/payments'

import { PayPalButton, PayPalButtonV2, TPayPalButton } from '@/components/payPalButton'
import {
  StripeCheckoutForm,
  StripeCheckoutFormV2,
  TStripeCheckoutFormProps,
} from '@/components/stripeCheckoutForm'
import {
  TWalletPaymentButtonProps,
  TWalletPaymentButtonV2Props,
  WalletPaymentButton,
  WalletPaymentButtonV2,
} from '@/components/walletPaymentButton'

export const walletPaymentButtonMap: Record<
  CheckoutFlowVersion,
  FC<TWalletPaymentButtonProps> | FC<TWalletPaymentButtonV2Props>
> = {
  [CheckoutFlowVersion.V1]: WalletPaymentButton,
  [CheckoutFlowVersion.V2]: WalletPaymentButtonV2,
}

export const paypalButtonMap: Record<CheckoutFlowVersion, FC<TPayPalButton>> = {
  [CheckoutFlowVersion.V1]: PayPalButton,
  [CheckoutFlowVersion.V2]: PayPalButtonV2,
}

export const stripeCheckoutFormMap: Record<CheckoutFlowVersion, FC<TStripeCheckoutFormProps>> = {
  [CheckoutFlowVersion.V1]: StripeCheckoutForm,
  [CheckoutFlowVersion.V2]: StripeCheckoutFormV2,
}
